import { BoxProps } from '@withjoy/joykit';

export const PAGE_SECTION_HORIZONTAL_PADDING: BoxProps['paddingX'] = {
  _: 4,
  sm2: 6,
  md3: 8,
  lg1: 88,
  xl: 120
};
